import { Component, OnInit } from '@angular/core';
import { FAQ } from 'src/app/models/faq.model';
import { Praktischpage } from 'src/app/models/praktischpage.model';
import { FaqService } from 'src/app/services/faq.service';
import { MediaService } from 'src/app/services/media.service';
import { PageService } from 'src/app/services/page.service';

declare var accordeons:any;

@Component({
  selector: 'app-praktisch',
  templateUrl: './praktisch.component.html',
  styleUrls: ['./praktisch.component.sass']
})
export class PraktischComponent implements OnInit {

  pagedata: Praktischpage = new Praktischpage;
  faqs:FAQ[] = [];

  constructor(
    private pageService:PageService,
    private mediaService: MediaService,
    private faqService: FaqService
  ) { }

  ngOnInit(): void {


    this.pageService.getPage("praktisch").subscribe(data => {
      this.pagedata = data.data;

      this.pagedata.foto1 = this.mediaService.getMediaItemUrl(this.pagedata.foto1);
      this.pagedata.foto2 = this.mediaService.getMediaItemUrl(this.pagedata.foto2);
    });

    this.faqService.getFAQs().subscribe(data => {
      data.data.forEach((element: any) => {
        let faqitem = element;
        faqitem.foto = this.mediaService.getMediaItemUrl(faqitem.foto, null);
        faqitem.foto2 = this.mediaService.getMediaItemUrl(faqitem.foto2, null);
        this.faqs.push(faqitem);
      });

      setTimeout(() => {
        accordeons.initAccordeons();
      }, 500);
    });
  }
}
